import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeDailyFiveContentItemContent$key } from "scmp-app/queries/__generated__/homeDailyFiveContentItemContent.graphql";

import { Container, Headline, StyledEntityLink } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeDailyFiveContentItemContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref: forwardReference,
  reference: reference_,
}) => {
  const content = useFragment(
    graphql`
      fragment homeDailyFiveContentItemContent on Content {
        entityId
        urlAlias
        ...entityLink
        ...hooksContentItemProvidersContent @arguments(withHeadline: true)
      }
    `,
    reference_,
  );
  const providers = useContentItemProviders(content);

  return (
    <Container className={className} ref={forwardReference}>
      <StyledEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <Headline>
          {providers.headline({
            hideTooltip: true,
            preferSocialHeadline: true,
          })}
        </Headline>
      </StyledEntityLink>
    </Container>
  );
};

Component.displayName = "ContentItemDailyFive";

export const ContentItemDailyFive = withHighlightedHeadline(Component);
